// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Box } from '@mui/material';
import { PartyCredentialRequirement } from '@daml.js/utility-credential-v0/lib/Utility/Credential/V0/Credential';
import PartyDisplay from '../../components/PartyDisplay';
import RequiredClaims from './RequiredClaims';

interface CredentialRequirementsProps {
  credentialRequirements: PartyCredentialRequirement[];
}

const RequiredCredentials: React.FC<CredentialRequirementsProps> = ({ credentialRequirements }) => {
  return (
    <Box sx={{ width: '100%', py: 1 }}>
      {credentialRequirements.map((r) => (
        <Box
          key={r.issuer}
          component="div"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5,
            mb: 2,
            width: '100%',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            <Box component="span" sx={{ fontWeight: 500, minWidth: '60px' }}>
              issuer:
            </Box>
            <PartyDisplay party={r.issuer} />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            <Box component="span" sx={{ fontWeight: 500, minWidth: '60px' }}>
              claims:
            </Box>
            <Box component="span">
              <RequiredClaims requiredClaims={r.requiredClaims} />
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default RequiredCredentials;
